import React from "react";
import Modal from "./Modal";
import { Translate } from "react-redux-i18n";
import QRCode from "qrcode.react";
import { FaStore } from "react-icons/fa";
import "./styles/ModalStoreAbout.css";

function getStoreUrl(storeId) {
  if (!storeId) return "";
  return `${window.location.origin}/marketstore/show/${storeId}`;
}

function getInitial(name) {
  return (name || "S")
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");
}

function ModalStoreAbout({ isOpen, onClose, marketstore }) {
  const storeUrl = getStoreUrl(marketstore?.Id);
  const hasAboutText = Boolean(marketstore?.Home?.trim());

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="marketstore_about_us" />}
    >
      <div className="store-about-modal">
        <div className="store-about-modal-hero">
          {marketstore?.Logo ? (
            <img
              className="store-about-modal-avatar"
              src={marketstore.Logo}
              alt={marketstore.Name || "Store"}
            />
          ) : (
            <div className="store-about-modal-avatar store-about-modal-avatar--placeholder">
              {marketstore?.Name ? getInitial(marketstore.Name) : <FaStore />}
            </div>
          )}
          <h2 className="store-about-modal-name">{marketstore?.Name}</h2>
        </div>

        {storeUrl && (
          <div className="store-about-modal-qr">
            <p className="store-about-modal-qr-label">
              <Translate value="marketstore_about_qr_label" />
            </p>
            <div className="store-about-modal-qr-canvas">
              <QRCode value={storeUrl} size={168} level="M" includeMargin />
            </div>
            <p className="store-about-modal-qr-hint">
              <Translate value="marketstore_about_qr_hint" />
            </p>
            <a
              className="store-about-modal-link"
              href={storeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {storeUrl}
            </a>
          </div>
        )}

        <div className="store-about-modal-content">
          <h3 className="store-about-modal-content-title">
            <Translate value="marketstore_about_us" />
          </h3>
          {hasAboutText ? (
            <p className="store-about-modal-text">{marketstore.Home}</p>
          ) : (
            <p className="store-about-modal-empty">
              <Translate value="marketstore_about_empty" />
            </p>
          )}
        </div>

        <div className="store-about-modal-footer">
          <button
            type="button"
            className="store-about-modal-close"
            onClick={onClose}
          >
            <Translate value="ok" />
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalStoreAbout;
